import { inject } from '@angular/core';
import { CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';

import { EmployeeOverviewService } from '../services/employee-overview.service';

export const canActivateEmployeeMinijobOverview: CanActivateFn = (_, state: RouterStateSnapshot) => {
  const employeeOverview = inject(EmployeeOverviewService);
  const router = inject(Router);

  const hasAccess = employeeOverview.hasMinijob();

  if (!hasAccess) {
    // when guard fails we redirect to the parent url by stripping the minijob part
    const updatedUrl = state.url.replace(/\/(my-)?minijob/, '');
    return router.parseUrl(updatedUrl);
  }

  return hasAccess;
};
